var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 0.375C20.4922 0.375 20.4219 0.410156 20.3516 0.445312L14.375 2.625L8.32812 0.515625C8.08203 0.445312 7.83594 0.410156 7.58984 0.375C7.37891 0.375 7.13281 0.445312 6.88672 0.515625L1.57812 2.34375C1.15625 2.51953 0.875 2.94141 0.875 3.39844V15.5625C0.875 15.9141 1.12109 16.125 1.40234 16.125C1.47266 16.125 1.54297 16.125 1.61328 16.0898L7.625 13.875L13.6719 16.0195C13.8828 16.0898 14.1289 16.125 14.375 16.125C14.6211 16.125 14.832 16.0898 15.0781 16.0195L20.3867 14.1914C20.8086 14.0156 21.125 13.5938 21.125 13.1367V0.972656C21.125 0.621094 20.8438 0.375 20.5625 0.375ZM1.92969 3.43359L7.0625 1.64062V12.8906L1.96484 14.7891L1.92969 3.43359ZM8.1875 12.8906V1.64062L13.8125 3.64453V14.8945L8.1875 12.8906ZM14.9375 14.8945V3.64453L20 1.74609L20.0352 13.1016L14.9375 14.8945Z",
    fill: "#E07046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.87cd77b1b07ca142e4b774627055f6f5.svg";
export { ForwardRef as ReactComponent };